import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Star, ArrowRight, Lock, Users, Award, Clock, Smartphone, BookOpen, Gift, AlertTriangle, X, Zap } from 'lucide-react';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { CountdownTimer } from '../components/CountdownTimer';
import { FAQAccordion } from '../components/FAQAccordion';
import { UrgencyBar } from '../components/UrgencyBar';
import { StickyBottomCTA } from '../components/StickyBottomCTA';
export function SalesPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <div className="min-h-screen bg-[#FAF9F6] font-sans text-slate-800 overflow-x-hidden pb-24 sm:pb-0" data-id="element-58">
      <UrgencyBar data-id="element-59" />
      <SocialProofPopup data-id="element-60" />
      <StickyBottomCTA data-id="element-61" />

      {/* HERO SECTION */}
      <header className="relative bg-gradient-to-b from-white to-blue-50 pt-12 pb-20 px-4 md:px-8 lg:px-16 overflow-hidden" data-id="element-62">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-blue-100/30 skew-x-12 transform origin-top-right" data-id="element-63"></div>

        <div className="max-w-7xl mx-auto relative z-10" data-id="element-64">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-65">
            <motion.div initial="hidden" animate="visible" variants={fadeInUp} className="space-y-8 text-center lg:text-left" data-id="element-66">
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-bold border border-blue-200 shadow-sm" data-id="element-67">
                <Star className="w-4 h-4 fill-blue-600 text-blue-600" data-id="element-68" />
                <span data-id="element-69">Más de 1,500 alumnos felices</span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight font-serif" data-id="element-70">
                Usar el celular no debería darte{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-600" data-id="element-71">
                  miedo ni ansiedad
                </span>
              </h1>

              <p className="text-xl md:text-2xl text-slate-600 font-medium leading-relaxed" data-id="element-72">
                No sos vos.{' '}
                <span className="text-blue-700 font-bold bg-blue-50 px-1" data-id="element-73">
                  Está mal explicado.
                </span>{' '}
                Descubrí el método paso a paso para recuperar tu independencia
                digital sin depender de nadie.
              </p>

              {/* Testimonial Box */}
              <div className="bg-white p-4 rounded-xl border-l-4 border-blue-500 shadow-md max-w-lg mx-auto lg:mx-0 text-left" data-id="element-74">
                <div className="flex gap-1 text-yellow-400 mb-2" data-id="element-75">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-76" />)}
                </div>
                <p className="text-slate-700 italic text-sm" data-id="element-77">
                  "Por primera vez entiendo lo que hago. Mis nietos no lo pueden
                  creer."
                </p>
                <p className="text-xs text-slate-500 mt-1 font-bold" data-id="element-78">
                  — Marta, 62 años
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4" data-id="element-79">
                <motion.button whileHover={{
                scale: 1.02,
                translateY: -2
              }} whileTap={{
                scale: 0.98
              }} onClick={scrollToPurchase} className="w-full sm:w-auto bg-gradient-to-r from-blue-600 to-cyan-600 text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg shadow-blue-200 flex items-center justify-center gap-2" data-id="element-80">
                  QUIERO APRENDER AHORA <ArrowRight className="w-6 h-6" data-id="element-81" />
                </motion.button>
              </div>

              <div className="flex items-center justify-center lg:justify-start gap-4 text-sm text-slate-500 font-medium" data-id="element-82">
                <span className="flex items-center gap-1" data-id="element-83">
                  <Shield className="w-4 h-4 text-green-500" data-id="element-84" /> Garantía 7 días
                </span>
                <span className="flex items-center gap-1" data-id="element-85">
                  <Lock className="w-4 h-4 text-blue-500" data-id="element-86" /> Pago seguro
                </span>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative mx-auto lg:mr-0 max-w-md lg:max-w-full cursor-pointer group" onClick={scrollToPurchase} data-id="element-87">
              {/* Floating Badge */}
              <div className="absolute -top-6 -right-6 z-20 bg-yellow-400 text-blue-900 font-black text-xl w-24 h-24 rounded-full flex items-center justify-center transform rotate-12 shadow-xl border-4 border-white group-hover:scale-110 transition-transform duration-300" data-id="element-88">
                <div className="text-center leading-tight" data-id="element-89">
                  50%
                  <br data-id="element-90" />
                  <span className="text-sm" data-id="element-91">OFF</span>
                </div>
              </div>

              <div className="absolute -inset-4 bg-gradient-to-tr from-blue-200 to-cyan-200 rounded-3xl opacity-60 blur-2xl -z-10" data-id="element-92"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qFYHVew2Fp41i7vsjHK3Do/ChatGPT_Image_11_ene_2026,_16_33_43.png" alt="Manual Celular Sin Ayuda" className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white transform group-hover:-translate-y-2 transition-transform duration-500" data-id="element-93" />

              {/* Social Proof Floating Card */}
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-blue-100 flex items-center gap-3 max-w-xs z-20" data-id="element-94">
                <div className="flex -space-x-2" data-id="element-95">
                  {[1, 2, 3].map(i => <div key={i} className={`w-8 h-8 rounded-full border-2 border-white bg-blue-${i * 100 + 100} flex items-center justify-center text-xs font-bold text-blue-800`} data-id="element-96">
                      {String.fromCharCode(64 + i)}
                    </div>)}
                </div>
                <div data-id="element-97">
                  <div className="flex text-yellow-400 text-xs" data-id="element-98">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-current" data-id="element-99" />)}
                  </div>
                  <p className="text-xs font-bold text-slate-700" data-id="element-100">
                    4.9/5 de calificación
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </header>

      {/* SOCIAL PROOF NUMBERS */}
      <section className="py-12 bg-white border-b border-blue-50" data-id="element-101">
        <div className="max-w-6xl mx-auto px-4" data-id="element-102">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-103">
            <div className="space-y-2" data-id="element-104">
              <Users className="w-8 h-8 text-blue-600 mx-auto" data-id="element-105" />
              <p className="text-3xl font-bold text-slate-900" data-id="element-106">1,500+</p>
              <p className="text-slate-500 font-medium" data-id="element-107">Alumnos felices</p>
            </div>
            <div className="space-y-2" data-id="element-108">
              <Star className="w-8 h-8 text-yellow-400 mx-auto fill-current" data-id="element-109" />
              <p className="text-3xl font-bold text-slate-900" data-id="element-110">4.9/5</p>
              <p className="text-slate-500 font-medium" data-id="element-111">
                Calificación promedio
              </p>
            </div>
            <div className="space-y-2" data-id="element-112">
              <Award className="w-8 h-8 text-orange-500 mx-auto" data-id="element-113" />
              <p className="text-3xl font-bold text-slate-900" data-id="element-114">7 días</p>
              <p className="text-slate-500 font-medium" data-id="element-115">
                Garantía de devolución
              </p>
            </div>
            <div className="space-y-2" data-id="element-116">
              <Clock className="w-8 h-8 text-cyan-500 mx-auto" data-id="element-117" />
              <p className="text-3xl font-bold text-slate-900" data-id="element-118">24/7</p>
              <p className="text-slate-500 font-medium" data-id="element-119">Acceso de por vida</p>
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEM / EMPATHY */}
      <section className="py-20 px-4 bg-[#FAF9F6]" data-id="element-120">
        <div className="max-w-4xl mx-auto text-center" data-id="element-121">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} data-id="element-122">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 font-serif" data-id="element-123">
              Sé exactamente cómo te sentís
            </h2>
            <p className="text-xl text-slate-700 mb-6 leading-relaxed" data-id="element-124">
              Sos una persona capaz, que resolvió miles de problemas en tu vida.
              Criaste hijos, trabajaste, tomaste decisiones importantes.
            </p>
            <p className="text-xl text-slate-700 mb-6 leading-relaxed" data-id="element-125">
              Pero cuando agarrás el celular, sentís que todo cambió. Como si de
              repente no entendieras nada.
            </p>
            <div className="bg-red-50 border border-red-100 p-6 rounded-2xl inline-block mt-4" data-id="element-126">
              <p className="text-xl text-slate-800 font-medium" data-id="element-127">
                Y no es tu culpa.{' '}
                <span className="text-red-600 font-bold" data-id="element-128">
                  Nadie te explicó con paciencia.
                </span>
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* PAIN POINTS GRID */}
      <section className="py-16 px-4 bg-white" data-id="element-129">
        <div className="max-w-5xl mx-auto" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12 font-serif" data-id="element-131">
            ¿Te pasa esto todos los días?
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-132">
            {[{
            icon: '😟',
            title: 'Miedo a tocar algo mal',
            text: 'El temor a borrar algo importante o desconfigurar el teléfono te paraliza. Preferís no usarlo antes que equivocarte.'
          }, {
            icon: '😓',
            title: 'No querés molestar',
            text: 'Te da vergüenza preguntar siempre lo mismo a tus hijos o nietos. Sentís que no tienen paciencia y que sos una carga.'
          }, {
            icon: '😕',
            title: 'Te sentís excluido',
            text: 'Ves que todos manejan el celular con facilidad y vos seguís sin entender. Te sentís afuera del mundo digital.'
          }].map((item, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all" data-id="element-133">
                <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mb-6 text-4xl shadow-sm" data-id="element-134">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-800 mb-3" data-id="element-135">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-136">{item.text}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-20 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-137">
        <div className="max-w-6xl mx-auto" data-id="element-138">
          <div className="text-center mb-16" data-id="element-139">
            <span className="text-blue-600 font-bold tracking-wider uppercase text-sm bg-blue-100 px-3 py-1 rounded-full" data-id="element-140">
              La solución definitiva
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mt-4 mb-6 font-serif" data-id="element-141">
              Manual "Celular Sin Ayuda"
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto" data-id="element-142">
              El único método diseñado específicamente para mayores de 40 años
              que quieren independencia digital.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-143">
            <div className="space-y-8" data-id="element-144">
              {[{
              title: 'Lenguaje 100% cotidiano',
              text: 'Sin términos en inglés ni palabras técnicas. Hablamos como vos.'
            }, {
              title: 'Para Android y iPhone',
              text: 'No importa qué marca de celular tengas, el manual te sirve igual.'
            }, {
              title: 'A tu ritmo, sin presión',
              text: 'Podés leerlo cuando quieras, volver atrás las veces que necesites.'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className="flex gap-4 items-start bg-white p-6 rounded-xl shadow-sm border border-blue-50" data-id="element-145">
                  <div className="bg-green-100 p-2 rounded-full mt-1 flex-shrink-0" data-id="element-146">
                    <Check className="w-6 h-6 text-green-600" data-id="element-147" />
                  </div>
                  <div data-id="element-148">
                    <h3 className="text-xl font-bold text-slate-900" data-id="element-149">
                      {item.title}
                    </h3>
                    <p className="text-slate-600 mt-1" data-id="element-150">{item.text}</p>
                  </div>
                </motion.div>)}

              <div className="pt-4" data-id="element-151">
                <motion.button whileHover={{
                scale: 1.02
              }} onClick={scrollToPurchase} className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold py-4 px-10 rounded-full shadow-lg flex items-center justify-center gap-2" data-id="element-152">
                  QUIERO MI COPIA AHORA <ArrowRight className="w-5 h-5" data-id="element-153" />
                </motion.button>
              </div>
            </div>

            <div className="relative" data-id="element-154">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-300 to-cyan-300 rounded-full opacity-20 blur-3xl" data-id="element-155"></div>
              <motion.img whileHover={{
              scale: 1.02
            }} src="https://cdn.magicpatterns.com/uploads/qFYHVew2Fp41i7vsjHK3Do/ChatGPT_Image_11_ene_2026,_16_33_43.png" alt="Vista previa del manual" className="relative w-full h-auto rounded-2xl shadow-2xl border-4 border-white z-10" data-id="element-156" />
            </div>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED - NEW SECTION */}
      <section id="que-incluye" className="py-20 px-4 bg-white" data-id="element-157">
        <div className="max-w-6xl mx-auto" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-16 font-serif" data-id="element-159">
            ¿Qué vas a aprender exactamente?
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-160">
            {[{
            num: '01',
            title: 'Lo Básico Fundamental',
            desc: 'Perdé el miedo a tocar. Aprendé a configurar el volumen, brillo, tamaño de letra y conexión WiFi.'
          }, {
            num: '02',
            title: 'WhatsApp a Fondo',
            desc: 'Mandá audios, fotos, hacé videollamadas, creá grupos y borrá mensajes que enviaste por error.'
          }, {
            num: '03',
            title: 'Fotos y Recuerdos',
            desc: 'Sacá fotos lindas, organizalas en álbumes, borrá las que no sirven y compartilas con tu familia.'
          }, {
            num: '04',
            title: 'Internet y Búsquedas',
            desc: 'Buscá recetas, noticias, remedios o direcciones sin miedo a virus o páginas raras.'
          }, {
            num: '05',
            title: 'Trámites y Pagos',
            desc: 'Aprendé a usar apps de bancos y billeteras virtuales con total seguridad y confianza.'
          }, {
            num: '06',
            title: 'Seguridad Total',
            desc: 'Detectá estafas, bloqueá números molestos y mantené tu información privada y segura.'
          }].map((item, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-[#FAF9F6] p-8 rounded-2xl border border-slate-100 relative overflow-hidden group" data-id="element-161">
                <div className="absolute -right-4 -top-4 text-9xl font-black text-white opacity-50 group-hover:text-blue-100 transition-colors" data-id="element-162">
                  {item.num}
                </div>
                <div className="relative z-10" data-id="element-163">
                  <div className="w-12 h-12 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-bold text-xl mb-4 border border-blue-200" data-id="element-164">
                    {item.num}
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-165">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-166">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-167">
            <button onClick={scrollToPurchase} className="bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg transition-colors" data-id="element-168">
              SÍ, QUIERO APRENDER AHORA
            </button>
          </div>
        </div>
      </section>

      {/* VALUE COMPARISON - NEW SECTION */}
      <section className="py-20 px-4 bg-slate-800 text-white" data-id="element-169">
        <div className="max-w-5xl mx-auto" data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-serif" data-id="element-171">
            ¿Por qué elegir este manual?
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-172">
            {/* Traditional Option */}
            <div className="bg-slate-700/50 p-8 rounded-2xl border border-slate-600 opacity-80" data-id="element-173">
              <h3 className="text-2xl font-bold mb-6 text-slate-200" data-id="element-174">
                Cursos Tradicionales
              </h3>
              <ul className="space-y-4" data-id="element-175">
                <li className="flex items-center gap-3 text-slate-200" data-id="element-176">
                  <X className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-177" />
                  <span data-id="element-178">Horarios fijos e incómodos</span>
                </li>
                <li className="flex items-center gap-3 text-slate-200" data-id="element-179">
                  <X className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-180" />
                  <span data-id="element-181">Explican rápido y te perdés</span>
                </li>
                <li className="flex items-center gap-3 text-slate-200" data-id="element-182">
                  <X className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-183" />
                  <span data-id="element-184">Lenguaje técnico difícil</span>
                </li>
                <li className="flex items-center gap-3 text-slate-200" data-id="element-185">
                  <X className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-186" />
                  <span data-id="element-187">Si te olvidás, no podés repasar</span>
                </li>
                <li className="flex items-center gap-3 text-slate-200" data-id="element-188">
                  <X className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-189" />
                  <span data-id="element-190">Costosos ($50.000+)</span>
                </li>
              </ul>
            </div>

            {/* Our Product */}
            <motion.div whileHover={{
            scale: 1.02
          }} className="bg-white text-slate-900 p-8 rounded-2xl border-4 border-orange-400 shadow-2xl relative" data-id="element-191">
              <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-orange-400 text-white font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide shadow-md" data-id="element-192">
                Mejor Opción
              </div>

              <h3 className="text-2xl font-bold mb-6 text-slate-900" data-id="element-193">
                Manual Celular Sin Ayuda
              </h3>
              <ul className="space-y-4" data-id="element-194">
                <li className="flex items-center gap-3 font-medium" data-id="element-195">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-196" />
                  <span data-id="element-197">A tu ritmo, en tu casa</span>
                </li>
                <li className="flex items-center gap-3 font-medium" data-id="element-198">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-199" />
                  <span data-id="element-200">Paso a paso con fotos claras</span>
                </li>
                <li className="flex items-center gap-3 font-medium" data-id="element-201">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-202" />
                  <span data-id="element-203">Lenguaje 100% cotidiano</span>
                </li>
                <li className="flex items-center gap-3 font-medium" data-id="element-204">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-205" />
                  <span data-id="element-206">Acceso de por vida para repasar</span>
                </li>
              </ul>
            </motion.div>
          </div>

          <div className="mt-12 text-center" data-id="element-207">
            <button onClick={scrollToPurchase} className="bg-green-500 hover:bg-green-600 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg transition-colors" data-id="element-208">
              SÍ, QUIERO APRENDER AHORA
            </button>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-20 px-4 bg-[#FAF9F6] overflow-hidden relative" data-id="element-209">
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-210">
          <div className="text-center mb-12" data-id="element-211">
            <motion.div animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            repeat: Infinity,
            duration: 2
          }} className="inline-block bg-red-500 text-white font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide mb-6 shadow-lg" data-id="element-212">
              🔥 Solo por hoy
            </motion.div>
            <h2 className="text-3xl md:text-5xl font-bold mb-4 text-slate-900 font-serif" data-id="element-213">
              REGALOS EXCLUSIVOS
            </h2>
            <p className="text-xl text-slate-600 mb-8" data-id="element-214">
              Llevate estos 3 bonos{' '}
              <span className="font-bold text-green-600" data-id="element-215">GRATIS</span> con tu
              compra
            </p>

            <div className="flex justify-center mb-12" data-id="element-216">
              <CountdownTimer variant="dark" data-id="element-217" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-218">
            {[{
            img: 'https://cdn.magicpatterns.com/uploads/1NM2LF7S3LVZBWx5cXQyr6/ChatGPT_Image_11_ene_2026,_17_36_21.png',
            title: 'IA Fácil en tu Celular',
            desc: 'Aprendé a usar ChatGPT para que te ayude a escribir mensajes, buscar recetas o resumir textos.',
            value: '$8.000'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/2ucM1GD4B79DLRsVEXL2vS/ChatGPT_Image_11_ene_2026,_17_37_01.png',
            title: 'Mercado Pago Experto',
            desc: 'La guía definitiva para comprar, pagar servicios, transferir dinero y cobrar sin miedos.',
            value: '$10.000'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/dcS9kBUAbjmdLzArkwN6bz/ChatGPT_Image_11_ene_2026,_17_38_26.png',
            title: 'Guía Anti-Estafas',
            desc: 'Protegé tu dinero. Aprendé a detectar mensajes falsos y llamadas sospechosas al instante.',
            value: '$12.000'
          }].map((bonus, i) => <motion.div key={i} whileHover={{
            y: -10
          }} className="bg-white rounded-2xl p-6 border border-blue-100 shadow-lg relative overflow-hidden" data-id="element-219">
                <div className="absolute top-4 right-4 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md z-10" data-id="element-220">
                  GRATIS
                </div>
                <div className="mb-6 overflow-hidden rounded-xl shadow-md" data-id="element-221">
                  <img src={bonus.img} alt={bonus.title} className="w-full h-auto transform hover:scale-105 transition duration-500" data-id="element-222" />
                </div>
                <h3 className="text-xl font-bold mb-2 text-slate-900" data-id="element-223">
                  {bonus.title}
                </h3>
                <p className="text-slate-600 text-sm mb-4" data-id="element-224">{bonus.desc}</p>
                <div className="pt-4 border-t border-slate-100 flex justify-between items-center" data-id="element-225">
                  <span className="text-xs text-slate-400 font-bold uppercase" data-id="element-226">
                    Valor Real:
                  </span>
                  <span className="text-slate-400 line-through font-bold" data-id="element-227">
                    {bonus.value}
                  </span>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-228">
            <p className="text-2xl font-bold text-slate-800 mb-6" data-id="element-229">
              Valor total de los regalos:{' '}
              <span className="line-through text-slate-400" data-id="element-230">$30.000</span>{' '}
              <span className="text-green-600" data-id="element-231">GRATIS HOY</span>
            </p>
            <motion.button whileHover={{
            scale: 1.05
          }} onClick={scrollToPurchase} className="bg-green-500 hover:bg-green-600 text-white text-xl font-bold py-4 px-12 rounded-full shadow-xl flex items-center justify-center gap-2 mx-auto" data-id="element-232">
              QUIERO MIS REGALOS <Gift className="w-6 h-6" data-id="element-233" />
            </motion.button>
          </div>
        </div>
      </section>

      {/* PAYMENT TUTORIAL SECTION - NEW */}
      <section className="py-16 px-4 bg-white border-y border-blue-100" data-id="element-234">
        <div className="max-w-5xl mx-auto" data-id="element-235">
          <div className="text-center mb-12" data-id="element-236">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 font-serif" data-id="element-237">
              ¿Cómo realizar tu compra?
            </h2>
            <p className="text-lg text-slate-600" data-id="element-238">
              Es muy simple. Seguí estos pasos y en menos de 2 minutos tenés tu
              manual:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-239">
            {/* Step 1 - Checkout Form */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-slate-50 rounded-2xl p-6 border border-slate-200" data-id="element-240">
              <div className="flex items-center gap-3 mb-4" data-id="element-241">
                <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg" data-id="element-242">
                  1
                </div>
                <h3 className="text-xl font-bold text-slate-900" data-id="element-243">
                  Completá tus datos
                </h3>
              </div>
              <div className="bg-white rounded-xl overflow-hidden border border-slate-200 shadow-sm mb-4" data-id="element-244">
                <img src="https://cdn.magicpatterns.com/uploads/k9Tf3DsuaHs9nTiMJeAtNJ/ASD1.png" alt="Paso 1: Formulario de checkout" className="w-full h-auto" data-id="element-245" />
              </div>
              <ul className="space-y-2 text-slate-700" data-id="element-246">
                <li className="flex items-start gap-2" data-id="element-247">
                  <span className="text-blue-600 font-bold mt-1" data-id="element-248">•</span>
                  <span data-id="element-249">Ingresá tu email para recibir el manual</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-250">
                  <span className="text-blue-600 font-bold mt-1" data-id="element-251">•</span>
                  <span data-id="element-252">Seleccioná Mercado Pago como método de pago</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-253">
                  <span className="text-blue-600 font-bold mt-1" data-id="element-254">•</span>
                  <span data-id="element-255">Completá los datos de facturación</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-256">
                  <span className="text-blue-600 font-bold mt-1" data-id="element-257">•</span>
                  <span data-id="element-258">Hacé clic en "Pagar ahora"</span>
                </li>
              </ul>
            </motion.div>

            {/* Step 2 - Payment Method */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-slate-50 rounded-2xl p-6 border border-slate-200" data-id="element-259">
              <div className="flex items-center gap-3 mb-4" data-id="element-260">
                <div className="bg-green-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg" data-id="element-261">
                  2
                </div>
                <h3 className="text-xl font-bold text-slate-900" data-id="element-262">
                  Elegí cómo pagar
                </h3>
              </div>
              <div className="bg-white rounded-xl overflow-hidden border border-slate-200 shadow-sm mb-4" data-id="element-263">
                <img src="https://cdn.magicpatterns.com/uploads/j1UpApXvSSQaUxZmwTZDDt/asd2.png" alt="Paso 2: Selección de método de pago" className="w-full h-auto" data-id="element-264" />
              </div>
              <ul className="space-y-2 text-slate-700" data-id="element-265">
                <li className="flex items-start gap-2" data-id="element-266">
                  <span className="text-green-600 font-bold mt-1" data-id="element-267">•</span>
                  <span data-id="element-268">Podés pagar con dinero disponible en Mercado Pago</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-269">
                  <span className="text-green-600 font-bold mt-1" data-id="element-270">•</span>
                  <span data-id="element-271">O con tarjeta de crédito/débito</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-272">
                  <span className="text-green-600 font-bold mt-1" data-id="element-273">•</span>
                  <span data-id="element-274">Elegí el método que prefieras y confirmá</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-275">
                  <span className="text-green-600 font-bold mt-1" data-id="element-276">•</span>
                  <span className="font-bold" data-id="element-277">
                    ¡Listo! Recibís el manual en tu email al instante
                  </span>
                </li>
              </ul>
            </motion.div>
          </div>

          <div className="mt-8 bg-blue-50 border border-blue-200 rounded-xl p-6 text-center" data-id="element-278">
            <p className="text-slate-700 font-medium" data-id="element-279">
              <span className="text-blue-600 font-bold" data-id="element-280">💡 Importante:</span> Si
              no tenés cuenta en Mercado Pago, no te preocupes. Podés pagar
              igualmente con tarjeta de crédito o débito sin necesidad de
              registrarte.
            </p>
          </div>
        </div>
      </section>

      {/* PRICING / FINAL CTA */}
      <section id="compra" className="py-20 px-4 bg-gradient-to-br from-slate-900 to-blue-900 text-white relative overflow-hidden" data-id="element-281">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-282"></div>

        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-283">
          <div className="inline-block bg-orange-500 text-white font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide mb-8 animate-pulse shadow-lg border-2 border-orange-400" data-id="element-284">
            ⚠️ Solo quedan 3 copias al 50% OFF
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-6 font-serif" data-id="element-285">
            Recuperá tu independencia hoy
          </h2>

          <div className="flex justify-center mb-8" data-id="element-286">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/20" data-id="element-287">
              <p className="text-sm text-blue-200 mb-2 uppercase tracking-widest font-bold" data-id="element-288">
                La oferta termina en:
              </p>
              <CountdownTimer variant="dark" className="scale-125" data-id="element-289" />
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 border-4 border-orange-400 max-w-2xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-290">
            <div className="absolute top-0 right-0 bg-orange-500 text-white text-xs font-bold px-4 py-1 rounded-bl-xl" data-id="element-291">
              50% DESCUENTO
            </div>

            {/* Social Proof inside card */}
            <div className="flex items-center justify-center gap-2 mb-6 bg-blue-50 py-2 px-4 rounded-full w-fit mx-auto" data-id="element-292">
              <div className="flex -space-x-2" data-id="element-293">
                {[1, 2, 3].map(i => <div key={i} className={`w-6 h-6 rounded-full border-2 border-white bg-blue-${i * 100 + 200}`} data-id="element-294"></div>)}
              </div>
              <p className="text-xs font-bold text-blue-800" data-id="element-295">
                127 personas compraron hoy
              </p>
            </div>

            <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8" data-id="element-296">
              <span className="text-2xl text-slate-400 line-through" data-id="element-297">
                $35.000
              </span>
              <span className="text-6xl font-black text-blue-600" data-id="element-298">$19.990</span>
              <span className="text-xl text-slate-500" data-id="element-299">ARS</span>
            </div>

            <div className="space-y-3 mb-10 text-left max-w-sm mx-auto" data-id="element-300">
              <div className="flex items-center gap-3 text-slate-700" data-id="element-301">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-302" />
                <span className="font-medium" data-id="element-303">
                  Manual completo en PDF (Android + iPhone)
                </span>
              </div>
              <div className="flex items-center gap-3 text-slate-700" data-id="element-304">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-305" />
                <span className="font-medium" data-id="element-306">3 Bonos de Regalo GRATIS</span>
              </div>
              <div className="flex items-center gap-3 text-slate-700" data-id="element-307">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-308" />
                <span className="font-medium" data-id="element-309">
                  Acceso inmediato y de por vida
                </span>
              </div>
              <div className="flex items-center gap-3 text-slate-700" data-id="element-310">
                <Shield className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-311" />
                <span className="font-bold text-blue-600" data-id="element-312">
                  Garantía total de 7 días
                </span>
              </div>
            </div>

            <motion.a href="https://checkout3.rosetadigital.com/cart/45857309196473:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-green-500 hover:bg-green-600 text-white text-2xl md:text-3xl font-black py-6 px-4 rounded-xl shadow-xl transform transition mb-4 uppercase leading-tight" data-id="element-313">
              DESCARGAR AHORA
            </motion.a>

            <p className="text-xs text-slate-500 font-medium flex items-center justify-center gap-2" data-id="element-314">
              <Zap className="w-3 h-3 text-yellow-500 fill-current" data-id="element-315" /> Acceso
              inmediato • Sin riesgos • Garantía 7 días
            </p>
          </div>

          <p className="mt-8 text-blue-300 text-sm flex items-center justify-center gap-2 opacity-80" data-id="element-316">
            <Lock className="w-4 h-4" data-id="element-317" /> Tus datos están 100% protegidos con
            encriptación SSL de 256-bits
          </p>
        </div>
      </section>

      {/* GUARANTEE SECTION - NOW AFTER PRICING */}
      <section className="py-16 px-4 bg-white border-y border-slate-100" data-id="element-318">
        <div className="max-w-4xl mx-auto" data-id="element-319">
          <div className="flex flex-col md:flex-row items-center gap-8 bg-blue-50 p-8 rounded-3xl border border-blue-100" data-id="element-320">
            <div className="flex-shrink-0" data-id="element-321">
              <Shield className="w-24 h-24 text-blue-600" data-id="element-322" />
            </div>
            <div className="text-center md:text-left" data-id="element-323">
              <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-324">
                Garantía de Hierro por 7 Días
              </h3>
              <p className="text-lg text-slate-700 mb-4" data-id="element-325">
                Estamos tan seguros de que este manual va a cambiar tu relación
                con la tecnología que asumimos todo el riesgo.
              </p>
              <p className="text-slate-600 font-medium" data-id="element-326">
                Si no estás 100% satisfecho, te devolvemos tu dinero. Sin
                preguntas, sin vueltas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 bg-[#FAF9F6]" data-id="element-327">
        <div className="max-w-6xl mx-auto" data-id="element-328">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12 font-serif" data-id="element-329">
            Ellos ya perdieron el miedo
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-330">
            {[{
            name: 'María',
            age: 52,
            city: 'Buenos Aires',
            text: 'Por primera vez entiendo lo que hago con el celular. Sin apuro y sin miedo. Me siento mucho más tranquila.',
            color: 'blue'
          }, {
            name: 'Carlos',
            age: 61,
            city: 'Rosario',
            text: 'Dejé de pedir ayuda a mis nietos para todo. Eso ya vale la pena la inversión. Muy recomendado.',
            color: 'green'
          }, {
            name: 'Laura',
            age: 47,
            city: 'Córdoba',
            text: 'Está explicado como me gusta. Claro y simple, sin vueltas raras. Las fotos ayudan muchísimo.',
            color: 'purple'
          }, {
            name: 'Jorge',
            age: 65,
            city: 'Mendoza',
            text: 'Aprendí a pagar y transferir sin miedo. Antes iba al banco para todo, ahora lo hago desde el sillón.',
            color: 'orange'
          }, {
            name: 'Ana',
            age: 58,
            city: 'La Plata',
            text: 'No es un curso aburrido. Es un manual de verdad que tenés a mano cuando lo necesitás.',
            color: 'pink'
          }, {
            name: 'Roberto',
            age: 70,
            city: 'Santa Fe',
            text: 'Pensé que ya era tarde para mí, pero este manual me demostró que no. Ahora uso WhatsApp mejor que mis hijos.',
            color: 'indigo'
          }].map((t, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100" data-id="element-331">
                <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-332">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-333" />)}
                </div>
                <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-334">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-slate-50" data-id="element-335">
                  <div className={`w-10 h-10 bg-${t.color}-100 rounded-full flex items-center justify-center text-${t.color}-600 font-bold`} data-id="element-336">
                    {t.name[0]}
                  </div>
                  <div data-id="element-337">
                    <p className="font-bold text-slate-900" data-id="element-338">
                      {t.name}, {t.age} años
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-339">{t.city}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-340">
            <button onClick={scrollToPurchase} className="bg-blue-600 hover:bg-blue-700 text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg transition-colors" data-id="element-341">
              SÍ, QUIERO APRENDER AHORA
            </button>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-20 px-4 bg-white" data-id="element-342">
        <div className="max-w-3xl mx-auto" data-id="element-343">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12 font-serif" data-id="element-344">
            Preguntas Frecuentes
          </h2>
          <FAQAccordion data-id="element-345" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-slate-950 text-slate-500 py-12 px-4 text-center border-t border-slate-900" data-id="element-346">
        <div className="max-w-6xl mx-auto" data-id="element-347">
          <p className="mb-4 font-medium" data-id="element-348">
            © 2024 Manual Celular Sin Ayuda. Todos los derechos reservados.
          </p>
          <p className="text-xs max-w-2xl mx-auto leading-relaxed opacity-60" data-id="element-349">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}